import { Alert, alpha, lighten, styled } from '@mui/material';

export const EditorRoot = styled('main')(({ theme }) => ({
  height: '100dvh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.default,
  overflow: 'hidden',
  '& > .MuiAlert-root': { margin: theme.spacing(1.5, 2, 0) },
  '& > .MuiAlert-root + iframe': { marginTop: theme.spacing(1.5) },
}));

export const EditorStatusAlert = styled(Alert)(({ theme, severity = 'error' }) => ({
  flexShrink: 0,
  padding: theme.spacing(1.5, 2),
  color: theme.palette.text.primary,
  backgroundColor: lighten(theme.palette[severity].main, 0.94),
  border: `1px solid ${alpha(theme.palette[severity].main, 0.2)}`,
  borderRadius: theme.spacing(1.5),
  lineHeight: 1.5,
  '& .MuiAlert-message': { minWidth: 0, padding: 0, overflowWrap: 'anywhere' },
  '& .MuiAlert-icon': { padding: 0, opacity: 1 },
  '& .MuiAlert-icon .MuiSvgIcon-root': { color: theme.palette[severity].dark },
}));

export const EditorHeader = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 2),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const EditorFrame = styled('iframe')({
  display: 'block',
  width: '100%',
  flex: 1,
  minHeight: 0,
  border: 0,
});
